import {JobBDPChangeNotificationDataApiDto} from "../../../../api/model/rest";
import AuthenticatedEntity from "../../../user/AuthenticatedEntity";
import {Option, option} from "ts-option";

/**
 * Job BDP change notification class data.
 */
export default class JobBDPChangeNotificationData {
	/**
	 *
	 * @param {string} jobId
	 * @param {string} entity Entity from who assignee change originates.
	 * @param {Option<string>} previousBusinessDevelopmentPartnerId id of the previous business development partner.
	 * @param {Option<string>} currentBusinessDevelopmentPartnerId id of the current business development partner.
	 * @param {string} referenceNumber
	 */
	constructor(readonly jobId: string,
		readonly entity: AuthenticatedEntity,
		readonly previousBusinessDevelopmentPartnerId: Option<string>,
		readonly currentBusinessDevelopmentPartnerId: Option<string>,
		readonly referenceNumber: string) {}

	static fromJson(json: JobBDPChangeNotificationDataApiDto): JobBDPChangeNotificationData {
		const creator = AuthenticatedEntity.fromJson(json.entity);
		return new JobBDPChangeNotificationData(json.jobId, creator, option(json.previousBusinessDevelopmentPartnerId),
			option(json.currentBusinessDevelopmentPartnerId), json.referenceNumber);
	}

	getJobReferenceNumber() {
		return this.referenceNumber
	}
}
